export default {
      id: "plus-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#plus",
      toString: function () {
        return this.url;
      }
    }